import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";

export interface GetEquipmentCertificateRequest {
  equipmentId: string;
}

export async function getEquipmentCertificate(
  request: GetEquipmentCertificateRequest
): Promise<Response<string>> {
  const responseResult = await tryCatch(
    fetch(
      `${API_BASE_URL}/api/v1/equipos/${request.equipmentId}/certificados`,
      {
        method: "GET",
        credentials: "include",
      }
    )
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err
      ? Err({
          message: `Error al obtener certificado del equipo: ${errorMessageResult.val.message}`,
          devMessage: errorMessageResult.val.message,
        })
      : Err({
          message: errorMessageResult.val.message,
          devMessage: errorMessageResult.val.devMessage,
        });
  }

  const dataResult = await tryCatch(response.text());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}
